import React, { useEffect, useMemo, useState } from 'react'
import { Accordion, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import KapalService from '../../../../services/kapal/KapalService'
import ChecklistTipe from '../../../../utilities/kapal/ChecklistTipe'
import SweetAlert from 'react-bootstrap-sweetalert'

const ModalInspeksiChecklist = ({ showChecklist, handleCloseChecklist, dataPpmKapal, dataDisposisi, reloadList, isEdit }) => {

    let kapalService = useMemo(() => new KapalService(), [])
    const [listChecklistCheck, setListChecklistCheck] = useState([])
    const [dataInspeksi, setDataInspeksi] = useState(null)
    const [listHasilChecklist, setListHasilChecklist] = useState([])

    useEffect(() => {
        if (!dataPpmKapal) return
        const fetchAllData = async () => {
            try {
                let isOver5Gt = dataPpmKapal.ukuranKapal <= 5 ? 'T' : 'Y'
                let isPembeku = dataPpmKapal.fasilitasPembeku === '1' ? 'Y' : 'T'

                const resChecklistCheck = await kapalService.checklistCek(isOver5Gt, isPembeku)
                setListChecklistCheck(resChecklistCheck.data.data)

                const resDataInspeksi = await kapalService.getInspeksiData(dataPpmKapal.nomorAjuKapal)
                if (resDataInspeksi) {
                    setDataInspeksi(resDataInspeksi.data)

                    const resDataInspeksiChecklist = await kapalService.listInspeksiChecklistByIdInspeksi(resDataInspeksi.data.idInspeksi)
                    setListHasilChecklist(resDataInspeksiChecklist.data.data)
                }

            } catch (error) {

            }
        }
        fetchAllData()
    }, [dataPpmKapal, kapalService])

    const [showConfirmProses, setShowConfirmProses] = useState(false)
    const handleCloseConfirmProses = () => setShowConfirmProses(false)
    const handleClickConfirmProses = () => {
        setShowConfirmProses(true)
    }

    const [loadingProses, setLoadingProses] = useState(false)
    const [showProsesSuccess, setShowProsesSuccess] = useState(false)
    const [showProsesFailed, setShowProsesFailed] = useState(false)

    const handleCloseSuccess = () => {
        setShowProsesSuccess(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleCloseFailed = () => {
        setShowProsesFailed(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleClickProses = async () => {
        setLoadingProses(true)
        try {
            console.log(listHasilChecklist)
            listHasilChecklist.map(async (hasil) => {
                let newHasil = {
                    ...hasil,
                    idInspeksi: dataInspeksi.idInspeksi,
                    nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date()
                }
                await kapalService.saveInspeksiChecklist(newHasil)
            })
            setShowConfirmProses(false)
            setShowProsesSuccess(true)
        } catch (error) {
            setShowConfirmProses(false)
            setShowProsesFailed(true)
        }
        setLoadingProses(false)
    }

    const handleClickClose = () => {
        // setHasilEvpDok([])
        // setValueCatatan('')
        // setValueKesimpulanOpt(null)
        handleCloseChecklist()
    }

    return (
        <>
            <Modal
                show={showChecklist}
                onHide={handleCloseChecklist}
                size='xl'
                centered
                scrollable
                backdrop='static'
            >
                <Modal.Header closeButton>
                    <Modal.Title><h5>Checklist Kapal</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju Kapal</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPpmKapal.nomorAjuKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Inspeksi</Form.Label>
                                    <Col sm="4">
                                        <Form.Control type="date" placeholder="NIB" className="form-control-sm" value={dataInspeksi && dataInspeksi.tglInspeksi} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-4'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Kapal</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.namaKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-3'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="6" className="control-label align-self-center mb-0" htmlFor="searchNib">Ukuran Kapal</Form.Label>
                                    <Col sm="4">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.ukuranKapal} disabled />
                                    </Col>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">GT</Form.Label>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Fasilitas Pembeku</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type='text' placeholder="alamat" className="form-control-sm" value={dataPpmKapal.fasilitasPembeku === '1' ? 'Dengan alat pembeku (freezer fishing vessel)' : 'Tanpa alat pembeku (non freezer fishing vessel)'} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Accordion defaultActiveKey="0">
                                {
                                    listChecklistCheck.map((check, idx) => (
                                        <Accordion.Item eventKey={idx.toString()} key={idx}>
                                            <Accordion.Header>{check.kodeTipe} - <ChecklistTipe kodeTipe={check.kodeTipe} /></Accordion.Header>
                                            <Accordion.Body>
                                                <Accordion defaultActiveKey={idx}>
                                                    <AccordionKelompok kodeTipe={check.kodeTipe} setListHasilChecklist={setListHasilChecklist} listHasilChecklist={listHasilChecklist} />
                                                </Accordion>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    ))
                                }
                            </Accordion>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && dataPpmKapal.kodeStatus === '023' && <Button variant="primary" size="sm" onClick={() => handleClickConfirmProses()}>Proses</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmProses &&
                <SweetAlert
                    title="Proses Checklist?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingProses ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickProses}
                    onCancel={handleCloseConfirmProses}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingProses}
                    reverseButtons
                >
                    {loadingProses && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showProsesSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Berhasil"
                    onConfirm={handleCloseSuccess}
                    btnSize="sm"
                />
            }
            {
                showProsesFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Gagal"
                    onConfirm={handleCloseFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

const AccordionKelompok = ({ kodeTipe, setListHasilChecklist, listHasilChecklist }) => {
    const [listChecklistKelompok, setListChecklistKelompok] = useState([])

    let kapalService = useMemo(() => new KapalService(), [])
    useEffect(() => {
        const fetchAllData = async () => {
            try {
                const resChecklistKelompok = await kapalService.checklistKelompok(kodeTipe)
                setListChecklistKelompok(resChecklistKelompok.data.data)
            } catch (error) {

            }
        }
        fetchAllData()
    }, [kapalService, kodeTipe])

    return (
        <>
            {
                listChecklistKelompok.map((kelompok, idxKelompok) => (
                    <Accordion.Item eventKey={idxKelompok.toString()} key={idxKelompok}>
                        <Accordion.Header>{kelompok.kodeKelompok} - {kelompok.uraianKelompok}</Accordion.Header>
                        <Accordion.Body>
                            <Accordion defaultActiveKey={idxKelompok}>
                                <AccordionSyarat kodeKelompok={kelompok.kodeKelompok} setListHasilChecklist={setListHasilChecklist} listHasilChecklist={listHasilChecklist} />
                            </Accordion>
                        </Accordion.Body>
                    </Accordion.Item>
                ))
            }
        </>
    )
}

const AccordionSyarat = ({ kodeKelompok, setListHasilChecklist, listHasilChecklist }) => {
    const [listChecklistSyarat, setListChecklistSyarat] = useState([])
    let kapalService = useMemo(() => new KapalService(), [])

    useEffect(() => {
        const fetchAllData = async () => {
            try {

                const resChecklistSyarat = await kapalService.checklistPersyaratan(kodeKelompok)
                setListChecklistSyarat(resChecklistSyarat.data.data)
            } catch (error) {

            }
        }
        fetchAllData()
    }, [kapalService, kodeKelompok])

    return (
        <>
            {
                listChecklistSyarat.map((syarat, idxSyarat) => (
                    <Accordion.Item eventKey={idxSyarat.toString()} key={idxSyarat}>
                        <Accordion.Header>{syarat.kodeSyarat} - {syarat.uraianSyarat}</Accordion.Header>
                        <Accordion.Body>
                            <Accordion defaultActiveKey={idxSyarat}>
                                <AccordionTarget kodeSyarat={syarat.kodeSyarat} setListHasilChecklist={setListHasilChecklist} listHasilChecklist={listHasilChecklist} />
                            </Accordion>
                        </Accordion.Body>
                    </Accordion.Item>
                ))
            }
        </>
    )
}

const AccordionTarget = ({ kodeSyarat, setListHasilChecklist, listHasilChecklist }) => {
    const [listChecklistTargetNilai, setListChecklistTargetNilai] = useState([])
    let kapalService = useMemo(() => new KapalService(), [])

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                const resChecklistTargetNilai = await kapalService.checklistTargetNilai(kodeSyarat)
                setListChecklistTargetNilai(resChecklistTargetNilai.data.data)
            } catch (error) {

            }
        }
        fetchAllData()
    }, [kapalService, kodeSyarat])

    const handleChangeRadio = (kodeTargetNilai, value) => {
        setListHasilChecklist((prev) => {
            const existing = prev.find((item) => item.kodeTargetNilai === kodeTargetNilai)
            if (existing) {
                return prev.map((item) =>
                    item.kodeTargetNilai === kodeTargetNilai ? { ...item, nilai: value } : item
                )
            } else {
                return [...prev, { kodeTargetNilai: kodeTargetNilai, nilai: value, keterangan: null }]
            }
        })
    }

    const handleChangeKeterangan = (kodeTargetNilai, value) => {
        setListHasilChecklist((prev) => {
            const existing = prev.find((item) => item.kodeTargetNilai === kodeTargetNilai)
            if (existing) {
                return prev.map((item) =>
                    item.kodeTargetNilai === kodeTargetNilai ? { ...item, keterangan: value } : item
                )
            } else {
                return [...prev, { kodeTargetNilai: kodeTargetNilai, keterangan: value, nilai: null }]
            }
        })
    }

    const renderRadioOptions = (kode, nilaiSaatIni, options) => (
        options.map(({ value, label }) => (
            <div key={value} className="form-check form-check-inline">
                <input
                    className="form-check-input"
                    type="radio"
                    name={'inlineRadio' + kode}
                    id={`inlineRadio${kode}-${value}`}
                    value={value}
                    checked={nilaiSaatIni === value}
                    onChange={(e) => handleChangeRadio(kode, Number(e.target.value))}
                />
                <label className="form-check-label" htmlFor={`inlineRadio${kode}-${value}`}>
                    {label}
                </label>
            </div>
        ))
    )

    return (
        <>
            {
                listChecklistTargetNilai.map((target, idxTarget) => {
                    const current = listHasilChecklist.find((h) => h.kodeTargetNilai === target.kodeTargetNilai)
                    const nilaiSaatIni = current?.nilai

                    const optionsSA = [
                        { value: 1, label: "Sesuai" },
                        { value: 0, label: "Tidak Sesuai" }
                    ]

                    const optionsDefault = [
                        { value: 0, label: "NA" },
                        { value: 1, label: "Kritis" },
                        { value: 2, label: "Mayor" },
                        { value: 3, label: "Minor" },
                        { value: 4, label: "OK" }
                    ]

                    const options = target.kodeTargetNilai.includes("SA") ? optionsSA : optionsDefault;

                    return (
                            <Form key={target.kodeTargetNilai}>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">{target.kodeTargetNilai} - {target.uraianTargetNilai}</Form.Label>
                                    <Col sm={target.kodeTargetNilai.includes("SA") ? "4" : "5"}>
                                        {renderRadioOptions(target.kodeTargetNilai, nilaiSaatIni, options)}
                                    </Col>
                                    <Col sm={target.kodeTargetNilai.includes("SA") ? "4" : "3"}>
                                        <Form.Control as='textarea'
                                            rows={4}
                                            placeholder="keterangan"
                                            className="form-control-sm"
                                            onChange={(e) => handleChangeKeterangan(target.kodeTargetNilai, e.target.value)}
                                            value={current?.keterangan ?? ""}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form> 
                    )
                })
            }
        </>
    )

}

export default ModalInspeksiChecklist